import { useMediaQuery } from 'react-responsive'

export const mediaQueries = {
    isDesktopOrLaptop: () => useMediaQuery({ query: '(min-width: 1224px)' }),
    isBigScreen: () => useMediaQuery({ query: '(min-width: 1824px)' }),
    isTabletOrMobile: () => useMediaQuery({ query: '(max-width: 1224px)' }),
    isSmallScreen: () => useMediaQuery({ query: '(max-width: 768px)' }),
    isPortrait: () => useMediaQuery({ query: '(orientation: portrait)' }),
    isRetina: () => useMediaQuery({ query: '(min-resolution: 2dppx)' }),
}

export const isMobile = () => (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));
export const isiOS = () => {
    return [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
    ].indexOf(navigator.platform) >= 0
        // iPad on iOS 13 detection
        || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
